import axiosInstance from '../../axios-config';

const patientPreferredLanguageUrl = 'api/patients/{patientId}/preferredLanguage';
const putPreferredLanguageUrl = '/api/users/{userId}/preferredLanguage?ietfCode={languageCode}';
const getTranslationsUrl = 'api/content/languagepack/patientPortal?language={language}&facilityId={facilityId}';
const getLanguageTranslationsUrl = 'api/languages/translations?language={languageCode}';

export const putPreferredLanguageApiCall = (userId, languageCode) =>
  axiosInstance.put(putPreferredLanguageUrl
    .replace('{userId}', userId).replace('{languageCode}', languageCode)
  );

export const putPatientPreferredLanguage = (patientId, languageCode) =>
  axiosInstance.put(`${patientPreferredLanguageUrl}?language=${languageCode}`
    .replace('{patientId}', patientId)
  );

export const getPatientPreferredLanguage = (patientId) =>
  axiosInstance.get(patientPreferredLanguageUrl
    .replace('{patientId}', patientId));

export const getTranslations = (language, facilityId) =>
  axiosInstance.get(getTranslationsUrl
    .replace('{language}', language).replace('{facilityId}', facilityId));


export const getLanguageTranslations = (languageCode) => (
  axiosInstance.get(getLanguageTranslationsUrl.replace('{languageCode}', languageCode))
);